import axios from 'axios';
import config from '../Config';

const apiClient = axios.create({
  baseURL: config.MerchantConfig.BASE_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((request) => {
  try {
    const tokens = JSON.parse(localStorage.getItem('tokens') || 'null');
    const accessToken = tokens?.access?.token || tokens?.access_token;
    if (accessToken) request.headers.Authorization = `Bearer ${accessToken}`;
  } catch {
    // A malformed local session should behave like a signed-out request.
  }
  return request;
});

const makeRequest = async (service, action, data = {}) => {
  const payload = { SERVICE: service, ACTION: action, ...data };
  const res = await apiClient.post('/api/action', payload);
  return res.data;
};

export { makeRequest, apiClient, axios as axiosInstance };
